import { render, staticRenderFns } from "./unassign-modal.vue?vue&type=template&id=4c453bc4&"
import script from "./unassign-modal.vue?vue&type=script&lang=ts&"
export * from "./unassign-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports